// Autofocus is intentional
/* eslint-disable jsx-a11y/no-autofocus */
import React, { forwardRef, useRef } from "../../../__compat__/react/main.entry.mjs.mjs";
import { useOverlay } from "../../../__compat__/@react-aria/overlays/main.entry.mjs.mjs";
import { useDialog } from "../../../__compat__/@react-aria/dialog/main.entry.mjs.mjs";
import { FocusScope } from "../../../__compat__/@react-aria/focus/main.entry.mjs.mjs";
import { useMergedRef } from "../../../hooks/useMergedRef.mjs.mjs";
import { pickAriaProps } from "../../../interfaces/commonProps.mjs.mjs";
import { Overlay } from "../Overlay/index.mjs.mjs";
import { StyledTray, StyledTrayContainer } from "./Tray.styles.mjs.mjs";
const TrayContainer = forwardRef(function TrayContainer({ children, open, onClose, autoFocus, ...restProps }, ref) {
    const trayRef = useRef(null);
    const getRef = useMergedRef(ref, trayRef);
    const { overlayProps } = useOverlay({
        onClose,
        isOpen: open,
        isDismissable: true,
    }, trayRef);
    const { dialogProps } = useDialog(pickAriaProps(restProps), trayRef);
    return (React.createElement(FocusScope, { contain: true, restoreFocus: true, autoFocus: autoFocus },
        React.createElement(StyledTrayContainer, null,
            React.createElement(StyledTray, { open: open, ...restProps, ...overlayProps, ...dialogProps, ref: getRef }, children))));
});
export const Tray = forwardRef(function Tray({ children, autoFocus = false, ...restProps }, ref) {
    const { open } = restProps;
    return (React.createElement(Overlay, { open: open, transitionDuration: 250, backdrop: true },
        React.createElement(TrayContainer, { ref: ref, autoFocus: autoFocus, ...restProps }, children)));
});
//# sourceMappingURL=Tray.mjs.mjs.map